import { create } from 'zustand';
import { MaintenanceStatus } from '../../types/maintenance';

type ActiveTab = 'all' | 'upcoming' | 'history';

interface MaintenanceListState {
  // Search and filters
  search: string;
  statusFilter: MaintenanceStatus[];
  activeTab: ActiveTab;
  // Pagination
  page: number;
  limit: number;
}

interface MaintenanceListActions {
  // Search and filter actions
  setSearch: (search: string) => void;
  setStatusFilter: (filter: MaintenanceStatus[]) => void;
  setActiveTab: (tab: ActiveTab) => void;
  // Pagination actions
  setPage: (page: number) => void;
  setLimit: (limit: number) => void;

  // Utility actions
  resetFilters: () => void;
  resetAll: () => void;
}

type MaintenanceListStore = MaintenanceListState & MaintenanceListActions;

const initialState: MaintenanceListState = {
  search: '',
  statusFilter: [],
  activeTab: 'all',
  page: 1,
  limit: 25,
};

export const useMaintenanceListStore = create<MaintenanceListStore>()((set) => ({
  ...initialState,

  // Search and filter actions
  setSearch: (search) => set({ search }),
  setStatusFilter: (statusFilter) => set({ statusFilter }),
  setActiveTab: (activeTab) => set({ activeTab }),
  setPage: (page) => set({ page }),
  setLimit: (limit) => set({ limit, page: 1 }),

  // Utility actions
  resetFilters: () => set({ search: '', statusFilter: [] }),
  resetAll: () => set(initialState),
}));
